import PropTypes from 'prop-types';
import React from 'react';
import { PlayContainerBase } from '../../../ui-components/PlayContainer/PlayContainer.styles';
import ErrorGeneral from './components/ErrorGeneral';
import ErrorOnline from './components/ErrorOnline';
import { Container, Heading } from './Error.styles';

export type ErrorProps = {
    pathname: string;
    isNetworkOnline: boolean;
};

const Error = ({ isNetworkOnline, pathname }: ErrorProps) => {
    const ErrorMessage = isNetworkOnline ? ErrorOnline : ErrorGeneral;

    return (
        <PlayContainerBase>
            <Container>
                <Heading>Sidan kunde inte laddas</Heading>
                <ErrorMessage pathname={pathname} />
            </Container>
        </PlayContainerBase>
    );
};

Error.propTypes = {
    pathname: PropTypes.string,
    isNetworkOnline: PropTypes.bool,
};

export default Error;
